import Constants from "../utils/consts";
var http = require("follow-redirects").https;
var qs = require("querystring");

export default async function updateRifiutaEvento(token) {
	return new Promise(function(resolve, reject) {
		var options = {
			method: "POST",
			hostname: Constants.ipAddress,
			path: Constants.apisFolder + "updateRifiutaEvento.php",
			headers: {
				"Content-Type": "application/x-www-form-urlencoded",
				Cookie: "uid=e02675a1a7516909792f6850dffcd5fe",
			},
			maxRedirects: 20,
		};

		var req = http.request(options, function(res) {
			var chunks = [];

			res.on("data", function(chunk) {
				chunks.push(chunk);
			});

			res.on("end", function() {
				var body = Buffer.concat(chunks);
				try {
					const resp = JSON.parse(body.toString());

					if (resp.success) {
						resolve(resp);
					} else {
						reject(new Error(resp.error || "Errore nella risposta del server"));
					}
				} catch (error) {
					reject(new Error("Errore di parsing della risposta del server"));
				}
			});

			res.on("error", function(error) {
				reject(error);
			});
		});

		var postData = qs.stringify({
			token: token,
		});

		req.write(postData);
		req.end();
	});
}
